

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 99 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5V3.5ZM98.8536 4.35355C99.0488 4.15829 99.0488 3.84171 98.8536 3.64645L95.6716 0.464466C95.4763 0.269204 95.1597 0.269204 94.9645 0.464466C94.7692 0.659728 94.7692 0.976311 94.9645 1.17157L97.7929 4L94.9645 6.82843C94.7692 7.02369 94.7692 7.34027 94.9645 7.53553C95.1597 7.7308 95.4763 7.7308 95.6716 7.53553L98.8536 4.35355ZM1 4.5H98.5V3.5H1V4.5Z","fill":"#4A3A59"}, []), "\n"]);
};

        